import React from 'react';
import SingleDatePicker from 'react-day-picker/DayPicker';
import { formatDate, parseDate, } from 'react-day-picker/moment';
import moment from 'moment';
import classNames from 'classnames';
import Cleave from 'cleave.js/dist/cleave-react';
import { Row, Col } from 'react-bootstrap'

import Loading from '../../components/shared/Loading'
import ConvertibleText from '../../components/shared/ConvertibleText'


class MinimumPremium extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            minimumEarnedPremium : props.limits.minimumEarnedPremium,
            date : props.limits.minimumEarnedPremiumDate
        };
        this.onBlurHandler = this.onBlurHandler.bind(this)
        this.handleDate = this.handleDate.bind(this)
        this.handleDateChange = this.handleDateChange.bind(this)
        this.handleOpenClander = this.handleOpenClander.bind(this)
    }
    componentWillReceiveProps(nextProps){
        this.setState({
            minimumEarnedPremium : (nextProps.limits.minimumEarnedPremium>100) ?
            this.state.minimumEarnedPremium : nextProps.limits.minimumEarnedPremium
        })

    }

    onBlurHandler(priceValue) {
        this.props.onBlurHandler(priceValue)
    }

    handleOpenClander() {
        this.setState({
            openC: true
        })
    }

    handleDate(day) {
        if (day) {
            this.setState({ date: day, openC: false});
            this.onBlurHandler({minimumEarnedPremiumDate: moment(day).format('MM/DD/YYYY')})
        }
     }

    handleDateChange(event) {
        if(event.target.value.length === 10) {
        this.setState({ date: event.target.value });
        this.onBlurHandler({minimumEarnedPremiumDate: moment(event.target.value).format('MM/DD/YYYY')})
        } else {
            this.setState({ dateHolder: event.target.value, date:'' });
            this.onBlurHandler({minimumEarnedPremiumDate: ''})
        }
    }

    YearMonthForm({ date, localeUtils, onChange}) {
        const months = localeUtils.getMonths();
        const currentYear = new Date().getFullYear();
        const fromMonth = new Date(currentYear-1, 0);
        const toMonth = new Date(currentYear + 10, 12);
        const years = [];
        for (let i = fromMonth.getFullYear(); i <= toMonth.getFullYear(); i += 1) {
          years.push(i);
        }
      
        const handleChange = function handleChange(e) {
           
          const { year, month } = e.target.form;
          onChange(new Date(year.value, month.value));
        };
      
        return (
          <form className="DayPicker-Caption">
            <select name="month" onChange={handleChange} value={date.getMonth()}>
              {months.map((month, i) => (
                <option key={month} value={i}>
                  {month}
                </option>
              ))}
            </select>
            <select name="year" onChange={handleChange} value={date.getFullYear()}>
              {years.map(year => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </select>
          </form>
        );
      }

    render() {
        const { isModified, manuallySetPricing, /*limits: { minimumEarnedPremium = {}} = {}, type*/ } = this.props
        let modifiedDate = new Date(this.state.date);
        return (
            <div className="gcLimitsContainer">
                <h4 className="quoteTitle">Minimum Premium</h4>
                <div>
                    <Row>
                        <Col xs={8} md={6}>
                            <div className="premiumGrid">
                                <span className="h5">Earned %</span>
                                <span className="h4">{ 
                                    isModified 
                                    ? <Loading width="23px" height="23px" /> 
                                    : <ConvertibleText 
                                        manuallySetPricing={manuallySetPricing}  
                                        value={{
                                            changePrefix: true,
                                            name: 'minimumEarnedPremium',
                                            text: this.state.minimumEarnedPremium
                                        }} 
                                        onBlurHandler={this.onBlurHandler}
                                    />
                                    }
                                </span>
                            </div>
                        </Col>
                        </Row>
                        {this.props.type === 'oi' && <Row>
                        <Col xs={8} md={6}>
                            <div className="premiumGrid">
                                <span className="h5" style={{paddingTop: "10px"}}>Project Specific - Fully Earned Premium Date</span>
                                <span className="h4">{ 
                                    isModified 
                                    ? <Loading width="23px" height="23px" /> 
                                    : (<div className="modalDatePicker col-xs-12"><div className='row' style={{marginLeft:'0px'}}>
                                    <Cleave
                                    id={'effDate'}
                                    className={classNames(
                                        'form-control',
                                        'number-control',
                                        'input-numeral',
                                        'col-xs-8',
                                        { filled: this.state.date ? moment(this.state.date).format('MM/DD/YYYY') : this.state.dateHolder },
                                    )}
                                    autoComplete={false}
                                    value={this.state.date ? moment(this.state.date).format('MM/DD/YYYY') : this.state.dateHolder}
                                    placeholder="mm/dd/yyyy"
                                    options={{
                                        date: true,
                                        datePattern: ['m', 'd', 'Y']
                                    }}
                                    onChange={this.handleDateChange}
                                /><button className="fa fa-calendar col-xs-1 btn calendarIcon" style={{marginLeft:'12px'}} onClick={this.handleOpenClander}></button>
                                   {this.state.openC && <SingleDatePicker
                                    formatDate={formatDate}
                                    parseDate={parseDate}
                                    month={!!this.state.date ? modifiedDate : ''}
                                    year={!!this.state.date ? modifiedDate.getFullYear(): ''}
                                    selected={this.state.date}
                                    placeholder={'mm/dd/yyyy'}
                                    onDayClick={this.handleDate}
                                    mode="single" 
                                    // disabledDays={(this.props.isUnderwriter ? {} : [{from: new Date(currentYear-1, 0), to: modifiedInitiatedDate}])}
                                    captionElement={({ date, localeUtils }) => (
                                        <this.YearMonthForm
                                            date={date}
                                            localeUtils={localeUtils}
                                            onChange={this.handleDate}
                                        //rangeOfYears={rangeOfYears}
                                        />
                                          )}
                                   />}
                                   </div></div>)
                                    }
                                </span>
                            </div>
                        </Col>
                    </Row>}
                </div>
            </div>
        )
    }
}

export default MinimumPremium